<meta-title i18n>מחשבון ציון התאמה</meta-title>

<div class="auth-page auth-page--wide">
  <ui-error [state]="loadState"></ui-error>

  <header class="auth-page-header" *visible="loadState.isCompleted">
    <h2 i18n>מחשבון ציון התאמה</h2>
    <p i18n>הזינו נתוני בגרות וציון פסיכומטרי או תיל לחישוב ציון ההתאמה</p>
  </header>

  <form
    class="auth-card auth-card--wide auth-card--plain"
    [formGroup]="form"
    autocomplete="off"
    novalidate
    *visible="loadState.isCompleted"
    (submit)="calculate()"
  >
    <bagrut-table [subjects]="subjects" [form]="form"></bagrut-table>

    <section class="auth-calculator-controls">
      <div class="auth-field">
        <label i18n>
          אנא הזן ציון
          {gradeType, select, psychometry {פסיכומטרי} other {תיל}}
        </label>
        <div class="auth-input-wrap auth-input-wrap--no-icon auth-input-wrap--grade">
          <input
            class="auth-input auth-input--with-toggle auth-input--with-toggle-wide"
            formControlName="grade"
            type="number"
            maxlength="3"
            max="999"
            min="0"
            placeholder="0"
          />

          <div
            class="auth-id-toggle"
            role="group"
            aria-label="אנא ביחרו סוג ציון"
            i18n-aria-label
          >
            <button
              type="button"
              [class.is-active]="gradeType === 'psychometry'"
              [attr.aria-pressed]="gradeType === 'psychometry'"
              (click)="setGradeType('psychometry')"
            >
              <mat-icon *ngIf="gradeType === 'psychometry'">check</mat-icon>
              <span i18n>פסיכומטרי</span>
            </button>
            <button
              type="button"
              [class.is-active]="gradeType === 'til'"
              [attr.aria-pressed]="gradeType === 'til'"
              (click)="setGradeType('til')"
            >
              <mat-icon *ngIf="gradeType === 'til'">check</mat-icon>
              <span i18n>תיל</span>
            </button>
          </div>
        </div>
      </div>

      <ui-progress-button
        class="auth-submit auth-submit--inline"
        color="primary"
        [disabled]="form.invalid"
        [state]="calculateState"
      >
        <span i18n>
          {calculateState.value, select, inProcess {מחשב ציון התאמה} other {חשב ציון התאמה}}
        </span>
      </ui-progress-button>
    </section>

    <div
      class="auth-result"
      [ngClass]="'auth-result--' + alertType"
      *visible="result && calculateState.isCompleted; transition: 'slide'"
    >
      <p class="auth-result__title" *ngIf="result?.hasHatama">
        <mat-icon>check_circle</mat-icon>
        <span i18n>סיכוייך לקבלה טובים</span>
      </p>

      <ng-container *ngIf="!result?.hasHatama || result?.finalGrade > 0">
        <p *ngIf="hasStatus('MissingMinimumRequirements')" i18n>
          עלך להזין נתוני בגרות במתמטיקה ואנגלית ולפחות 21 יח"ל
        </p>

        <div class="auth-result__score" *ngIf="result?.finalGrade > 0">
          <span class="auth-result__score-label" i18n>ציון ההתאמה שלך הוא</span>
          <span class="auth-result__score-value">{{ result?.finalGrade | number: '1.0-2' }}</span>
        </div>

        <p i18n *ngIf="hasStatus('NotMeetTheAdmissionRequirements')">
          ציון ההתאמה שלך קטן מ-79,
          <br />
          אנו ממליצים לך לפנות למדור מידע ורישום על מנת לקבל ייעוץ כיצד תוכל לשפר את סיכוייך להתקבל ללימודים.
          <br />
          בטלפון 1-700-50-32-32
        </p>
      </ng-container>
    </div>

    <ui-error [state]="calculateState"></ui-error>
  </form>

  <div class="auth-card auth-card--wide" *visible="loadState.isCompleted">
    <explanation-part></explanation-part>
  </div>
</div>
